import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EventEmitter } from '@angular/core';
import { SettingsProvider } from '../settings/settings';
import { Router } from '@angular/router';
import { HelperProvider } from '../helper/helper';

@Injectable()
export class SharedDataProvider {
  agentId = '';

  playByPlay = [];
  teams = [];

  agentInfo = {
    Description: '',
    Email: '',
    FAX: '',
    Fullname: '',
    Id: '',
    Phone: '',
    VAT: '',
  };
  agentAccount = {
    IsLocked: false,
    MaxCountAll: 0,
    CurrentCountAll: 0,
    MaxAmountVehicle: 0,
    CurrentAmountVehicle: 0,
    MaxAmountOther: 0,
    CurrentAmountOther: 0,
  };

  dashboardDetails = {
    clubDetails: {
      rank: 0,
    },
  };

  currentVerion;
  isLogged = false;
  isTablet = false;
  needIntro;

  needInfo = true;
  neeedDashboardDetails = true;
  needDashboardData = true;
  needLoadMessages = true;
  needWelcomeMessage = true;
  needGetAccount = true;
  eventEmitter = new EventEmitter();

  imagePickMethod;
  imageUploadData;
  cropImage;
  quotation;
  quotationParams;

  constructor() {}
}
